import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import item1 from "../../assets/images/03_img_1.jpg"
import item2 from "../../assets/images/03_img_2.png"
import item3 from "../../assets/images/03_img_3.png"
import item4 from "../../assets/images/03_img_4.jpg"
import MainList from "../../components/organisms/MainList";

const Program = () => {
    const programList = [
        {
            id: 1,
            title: "강아지숲 박물관",
            img: item1,
            link:"/program/museum"
        },
        {
            id: 2,
            title: "상설 프로그램",
            img: item2,
            link:"/program/permanent"
        },
        {
            id: 3,
            title: "특별 프로그램",
            img: item3,
            link:"/program/special"
        },
        {
            id: 4,
            title: "도그 스포츠",
            img: item4,
            link:"/program/dogsports"
        },
    ];

    return (
        <>
                <PageHeader
                    detail="프로그램"
                    desc="강아지숲의 다양한 프로그램을 안내해 드립니다."
                />
                <MainList
                    list={programList}
                    pagination={false}
                />
        </>
    );
};

export default Program;
